import { createFileRoute } from "@tanstack/react-router";
import SaintTherapyCoralSpringsFl from "@/pages/SaintTherapyCoralSpringsFl";
import {
  CLINIC_REF,
  buildBreadcrumbList,
  buildMedicalWebPage,
  SITE_URL,
} from "@/components/schemaConstants";
import { buildHreflang } from "@/lib/i18n/locale";

const PAGE_URL = `${SITE_URL}/saint-therapy-coral-springs-fl`;
const BREADCRUMB_ID = `${PAGE_URL}#breadcrumb`;

export const Route = createFileRoute("/saint-therapy-coral-springs-fl")({
  head: () => ({
    meta: [
      { title: "SAINT® TMS in Coral Springs, FL | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "SAINT® TMS in Coral Springs, FL — fMRI-guided 5-day accelerated TMS for treatment-resistant depression at Neuro Wellness TMS Centers of America. Free.",
      },
      {
        property: "og:title",
        content: "SAINT® TMS in Coral Springs, FL | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "fMRI-guided 5-day SAINT® TMS for treatment-resistant depression in Coral Springs, FL. Free consultation.",
      },
      {
        property: "og:url",
        content: PAGE_URL,
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: PAGE_URL },
      ...buildHreflang("/saint-therapy-coral-springs-fl"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildMedicalWebPage({
            name: "SAINT® TMS in Coral Springs, FL",
            description:
              "fMRI-guided 5-day accelerated TMS (SAINT®) for treatment-resistant depression in Coral Springs, FL.",
            url: PAGE_URL,
            id: `${PAGE_URL}#webpage`,
            breadcrumbId: BREADCRUMB_ID,
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbList(
            [
              { name: "Home", href: "/" },
              { name: "SAINT® TMS", href: "/saint" },
              {
                name: "Coral Springs, FL",
                href: "/saint-therapy-coral-springs-fl",
              },
            ],
            BREADCRUMB_ID,
          ),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalTherapy",
          "@id": `${SITE_URL}/saint#therapy`,
          name: "SAINT® Accelerated TMS",
          description:
            "FDA-cleared, fMRI-guided 5-day accelerated transcranial magnetic stimulation for adults with major depressive disorder who have not achieved adequate relief from antidepressants.",
          url: `${SITE_URL}/saint`,
          provider: CLINIC_REF,
        }),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintTherapyCoralSpringsFl />;
}
